"use client";
import { cn } from "@/lib/utils";
import { ErrorMessage } from "@hookform/error-message";
import { ComponentProps, PropsWithChildren } from "react";
import { useFormContext } from "react-hook-form";

export function ValidateMessage(props: ComponentProps<typeof ErrorMessage>) {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <ErrorMessage
      render={({ message }) => (
        <p className="pt-1 text-xs text-[#FF1B1B]">{message}</p>
      )}
      errors={errors}
      {...props}
    />
  );
}

export function ValidateFormItem(
  props: PropsWithChildren<{
    className?: string;
    name: string;
  }>
) {
  return (
    <div className={cn("relative flex flex-col", props.className)}>
      {props.children}

      <ValidateMessage name={props.name} />
    </div>
  );
}
